import { lazy } from 'react';

const AuthNavbar = lazy(() => import('./AuthNavbar'));

export default AuthNavbar;
